import * as React from "react";
const SvgFiRrWineBottle = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-wine-bottle_svg__a)">
      <path
        fill="#062147"
        d="m18.338 9.188-3.328-2.22V1.006a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v5.964L5.682 9.188a5.99 5.99 0 0 0-2.673 4.992v4.824c0 2.757 2.243 5 5 5h8.001c2.757 0 5-2.243 5-5V14.18a5.99 5.99 0 0 0-2.672-4.992m.672 9.816c0 1.654-1.346 3-3 3H8.009c-1.654 0-3-1.346-3-3v-4H16.01a1 1 0 0 0 0-2H5.185a4 4 0 0 1 1.606-2.152l3.773-2.516c.278-.186.445-.498.445-.832v-3.5h2v3.5c0 .334.167.646.445.832l3.773 2.516a3.99 3.99 0 0 1 1.781 3.328v4.824z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-wine-bottle_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrWineBottle;
